import { Fragment } from "react";
import { mobile } from "../../../constants/env";
import Link from "next/link";
import { useColors } from "../../../hooks/colors/useColors";
import { useTranslation } from "next-i18next";
import { Group, Text, UnstyledButton } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons";
import classes from "./user.module.css";
import { useUser } from "../../../hooks/react-query/useUser";

export function BackToProfile() {
  const { colors } = useColors();
  const { i18n } = useTranslation("common");
  const { user } = useUser();
  return (
    <div className="fixed z-50">
      {mobile && user && (
        <Link href="/user">
          <UnstyledButton className="ml-2 mt-2">
            <Group className={classes.animatedButton}>
              <IconChevronLeft color={colors.primary} />
              <div>
                <Text color={colors.primary}>{i18n.t("profile")}</Text>
              </div>
            </Group>
          </UnstyledButton>
        </Link>
      )}
    </div>
  );
}
